import { Collapse } from './collapse.js';

const build = () => {
  Collapse.build(document);
};

export default build;
